/* Page formacion scripts
========================================================================== */

if (document.querySelectorAll('.interno').length !== 0 || document.querySelectorAll('.externo').length !== 0) {
	window.onload = function () {
		let internos = document.querySelectorAll('.interno');
		for (let i = 0; i < internos.length; i++) {
			internos[i].addEventListener('click', mostrar_ventana_externa_oculta_derecha);
		}

		let barras_superiores_contenidos_items = document.querySelectorAll('.barra-superior-contenido-item');
		for (let i = 0; i < barras_superiores_contenidos_items.length; i++) {
			barras_superiores_contenidos_items[i].addEventListener('click', mostrar_contenido_item_acordeon);
		}
	}

	function mostrar_ventana_externa_oculta_derecha() {
		let externos = document.querySelectorAll('.externo');
		for (let i = 0; i < externos.length; i++) {
			if (this.dataset.numero === externos[i].dataset.numero) {
				externos[i].classList.toggle('ocultar');
			}
		}
	}

	function mostrar_contenido_item_acordeon() {
		// ESTE IF ES POR SI PULSA EN UNO ABIERTO PARA QUE SE CIERRE
		if (this.lastElementChild.classList.value == 'abierto') {
			this.nextElementSibling.classList.add('ocultar-contenido-item');
			this.lastElementChild.classList.remove('abierto'); // El signo de la derecha
			return;
		}
		let barras_superiores_contenidos_items = document.querySelectorAll('.barra-superior-contenido-item');
		for (let i = 0; i < barras_superiores_contenidos_items.length; i++) {
			barras_superiores_contenidos_items[i].nextElementSibling.classList.add('ocultar-contenido-item');
			barras_superiores_contenidos_items[i].lastElementChild.classList.remove('abierto'); // El signo de la derecha
		}
		for (let i = 0; i < barras_superiores_contenidos_items.length; i++) {
			if (barras_superiores_contenidos_items[i] === this) {
				this.nextElementSibling.classList.toggle('ocultar-contenido-item');
				this.lastElementChild.classList.toggle('abierto'); // El signo de la derecha
			}
		}
	}
}
